(() => {
  const MARKUP = `
    <span class="bnx-b-stack__layer"><svg viewBox="0 0 35.13 95.17" aria-hidden="true" focusable="false"><path d="M0,11.66s5.63,6.94,6.08,8.36.19,55.48.19,55.48c0,0,8.8,9.12,15.14,9.75l13.11-14.38-.44-32.55s0-3.36,1.77-3.99-12.98-4.62-12.98-4.62l-7.47,6.46,8.87,4.37s.63,32.55,0,35.59l-8.36-6.65s-.44-42.5.32-52.06l5.51-14.38s-10.96,6.21-12.67,10.01L0,11.66Z"/></svg></span>
    <span class="bnx-b-stack__layer"><svg viewBox="0 0 35.13 95.17" aria-hidden="true" focusable="false"><path d="M0,11.66s5.63,6.94,6.08,8.36.19,55.48.19,55.48c0,0,8.8,9.12,15.14,9.75l13.11-14.38-.44-32.55s0-3.36,1.77-3.99-12.98-4.62-12.98-4.62l-7.47,6.46,8.87,4.37s.63,32.55,0,35.59l-8.36-6.65s-.44-42.5.32-52.06l5.51-14.38s-10.96,6.21-12.67,10.01L0,11.66Z"/></svg></span>
    <span class="bnx-b-stack__layer"><svg viewBox="0 0 35.13 95.17" aria-hidden="true" focusable="false"><path d="M0,11.66s5.63,6.94,6.08,8.36.19,55.48.19,55.48c0,0,8.8,9.12,15.14,9.75l13.11-14.38-.44-32.55s0-3.36,1.77-3.99-12.98-4.62-12.98-4.62l-7.47,6.46,8.87,4.37s.63,32.55,0,35.59l-8.36-6.65s-.44-42.5.32-52.06l5.51-14.38s-10.96,6.21-12.67,10.01L0,11.66Z"/></svg></span>
    <span class="bnx-b-stack__layer"><svg viewBox="0 0 35.13 95.17" aria-hidden="true" focusable="false"><path d="M0,11.66s5.63,6.94,6.08,8.36.19,55.48.19,55.48c0,0,8.8,9.12,15.14,9.75l13.11-14.38-.44-32.55s0-3.36,1.77-3.99-12.98-4.62-12.98-4.62l-7.47,6.46,8.87,4.37s.63,32.55,0,35.59l-8.36-6.65s-.44-42.5.32-52.06l5.51-14.38s-10.96,6.21-12.67,10.01L0,11.66Z"/></svg></span>
    <span class="bnx-b-stack__layer"><svg viewBox="0 0 35.13 95.17" aria-hidden="true" focusable="false"><path d="M0,11.66s5.63,6.94,6.08,8.36.19,55.48.19,55.48c0,0,8.8,9.12,15.14,9.75l13.11-14.38-.44-32.55s0-3.36,1.77-3.99-12.98-4.62-12.98-4.62l-7.47,6.46,8.87,4.37s.63,32.55,0,35.59l-8.36-6.65s-.44-42.5.32-52.06l5.51-14.38s-10.96,6.21-12.67,10.01L0,11.66Z"/></svg></span>`;

  const addStack = (host, key) => {
    if (!host || host.querySelector(`[data-bnx-stack="${key}"]`)) return;
    const stack = document.createElement('span');
    stack.className = 'bnx-b-stack';
    stack.dataset.bnxStack = key;
    stack.setAttribute('aria-hidden', 'true');
    stack.innerHTML = MARKUP;
    host.appendChild(stack);
  };

  const copyDropSwatches = () => {
    document.querySelectorAll('[data-bn-drop-live] .bn-drop-card').forEach((card) => {
      const swatch = card.querySelector('.bn-drop-card__swatch');
      if (!swatch) return;
      const value = swatch.style.getPropertyValue('--drop-swatch');
      if (value) card.style.setProperty('--drop-swatch', value);
    });
  };

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let activeVideo = null;

  const videoTrack = (event, payload = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...payload });
  };

  const videoCard = (video) => video?.closest('.q-card,.bn-drop-card,.bn-mod-role,.card,[data-bnsv-step-card],[data-bnsv-split-media],.bnv2-hero');

  const setVideoState = (video, isPlaying) => {
    const card = videoCard(video);
    if (card) card.classList.toggle('is-video-playing', isPlaying);
    const trigger = card?.querySelector(':scope > .bnx-video-trigger, .media > .bnx-video-trigger');
    if (trigger) {
      trigger.setAttribute('aria-pressed', String(isPlaying));
      trigger.setAttribute('aria-label', `${isPlaying ? 'Wstrzymaj' : 'Odtwórz'} wideo`);
      trigger.querySelector('span').textContent = isPlaying ? 'Ⅱ' : '▶';
    }
  };

  const pauseVideo = (video, reset = false) => {
    if (!video) return;
    video.pause();
    if (reset) {
      try { video.currentTime = 0; } catch (error) { /* metadata is not loaded yet */ }
    }
    setVideoState(video, false);
    if (activeVideo === video) activeVideo = null;
  };

  const stopOtherVideos = (except) => {
    document.querySelectorAll('video').forEach((video) => {
      if (video !== except && !video.paused) pauseVideo(video);
    });
  };

  const playVideo = async (video, context = 'manual') => {
    if (!video) return false;
    stopOtherVideos(video);
    video.muted = true;
    video.playsInline = true;
    try {
      await video.play();
      activeVideo = video;
      setVideoState(video, true);
      videoTrack('video_start', { context, src: (video.currentSrc || '').split('?')[0] });
      return true;
    } catch (error) {
      setVideoState(video, false);
      return false;
    }
  };

  const primeDeferredVideo = (video) => {
    if (!video) return;
    video.autoplay = false;
    video.removeAttribute('autoplay');
    video.preload = 'none';
    video.setAttribute('preload', 'none');
    video.muted = true;
    video.playsInline = true;
    pauseVideo(video);
  };

  const selectVideoCard = (group, card, video, context, shouldPlay = true) => {
    group.querySelectorAll('.is-video-selected').forEach((item) => item.classList.remove('is-video-selected'));
    card.classList.add('is-video-selected');
    group.querySelectorAll('video').forEach((other) => {
      if (other !== video) pauseVideo(other, true);
    });
    if (shouldPlay) playVideo(video, context);
  };

  const addVideoTrigger = (card, video, context, group) => {
    if (!card || !video || card.querySelector(':scope > .bnx-video-trigger')) return;
    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'bnx-video-trigger';
    trigger.setAttribute('aria-label', 'Odtwórz wideo');
    trigger.setAttribute('aria-pressed', 'false');
    trigger.innerHTML = '<span aria-hidden="true">▶</span><small>VIDEO</small>';
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (!video.paused) pauseVideo(video);
      else selectVideoCard(group, card, video, `${context}_tap`);
    });
    card.appendChild(trigger);
  };

  const setupHeroVideo = () => {
    const hero = document.querySelector('.bnv2-hero');
    const video = hero?.querySelector('video');
    if (!hero || !video || hero.dataset.bnxVideoReady === 'true') return;
    hero.dataset.bnxVideoReady = 'true';
    video.preload = 'metadata';
    video.setAttribute('preload', 'metadata');
    video.muted = true;
    video.playsInline = true;

    const control = document.createElement('button');
    control.type = 'button';
    control.className = 'bnx-hero-video-control';
    control.setAttribute('aria-label', 'Wstrzymaj wideo w tle');
    control.innerHTML = '<span aria-hidden="true">Ⅱ</span><small>VIDEO</small>';
    hero.appendChild(control);

    let visible = false;
    let userPaused = false;
    const syncControl = () => {
      const playing = !video.paused;
      control.setAttribute('aria-pressed', String(playing));
      control.setAttribute('aria-label', playing ? 'Wstrzymaj wideo w tle' : 'Odtwórz wideo w tle');
      control.querySelector('span').textContent = playing ? 'Ⅱ' : '▶';
      hero.classList.toggle('is-video-playing', playing);
    };

    control.addEventListener('click', async () => {
      if (video.paused) {
        userPaused = false;
        await playVideo(video, 'home_hero_control');
      } else {
        userPaused = true;
        pauseVideo(video);
      }
      syncControl();
    });
    video.addEventListener('play', syncControl);
    video.addEventListener('pause', syncControl);

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        visible = Boolean(entries[0]?.isIntersecting);
        if (!visible) pauseVideo(video);
        else if (!reduceMotion.matches && !userPaused) playVideo(video, 'home_hero_view');
        syncControl();
      }, { threshold: .34 });
      observer.observe(hero);
    } else if (!reduceMotion.matches) {
      playVideo(video, 'home_hero_view');
    }

    reduceMotion.addEventListener?.('change', () => {
      if (reduceMotion.matches) pauseVideo(video);
      else if (visible && !userPaused) playVideo(video, 'home_hero_motion_change');
      syncControl();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) pauseVideo(video);
      else if (visible && !reduceMotion.matches && !userPaused) playVideo(video, 'home_hero_return');
    });
    syncControl();
  };

  const setupQuickVideos = () => {
    const group = document.querySelector('[data-bn-quick-clean]');
    if (!group || group.dataset.bnxVideoReady === 'true') return;
    group.dataset.bnxVideoReady = 'true';
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    group.querySelectorAll('.q-card').forEach((card) => {
      const video = card.querySelector('video');
      if (!video) return;
      primeDeferredVideo(video);
      addVideoTrigger(card, video, 'home_bestseller', group);
      if (finePointer.matches) {
        card.addEventListener('mouseenter', () => selectVideoCard(group, card, video, 'home_bestseller_hover'));
        card.addEventListener('mouseleave', () => pauseVideo(video, true));
      }
      card.addEventListener('focusin', (event) => {
        if (event.target.closest('.bnx-video-trigger')) return;
        selectVideoCard(group, card, video, 'home_bestseller_focus');
      });
      card.addEventListener('focusout', (event) => {
        if (!card.contains(event.relatedTarget)) pauseVideo(video, true);
      });
    });
  };

  const setupDropVideos = () => {
    const group = document.querySelector('[data-bn-drop-live]');
    if (!group || group.dataset.bnxVideoReady === 'true' || group.dataset.bnDropVersion === '3') return;
    group.dataset.bnxVideoReady = 'true';
    const cards = Array.from(group.querySelectorAll('.bn-drop-card')).filter((card) => card.querySelector('video'));
    cards.forEach((card) => {
      const video = card.querySelector('video');
      primeDeferredVideo(video);
      addVideoTrigger(card, video, 'home_drop', group);
    });
    if (!cards.length) return;
    selectVideoCard(group, cards[0], cards[0].querySelector('video'), 'home_drop_default', false);

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        const selected = group.querySelector('.bn-drop-card.is-video-selected') || cards[0];
        const video = selected.querySelector('video');
        if (entries[0]?.isIntersecting && !reduceMotion.matches) playVideo(video, 'home_drop_view');
        else pauseVideo(video);
      }, { threshold: .28 });
      observer.observe(group);
    }
  };

  const setupRoleVideos = () => {
    const group = document.querySelector('[data-bn-home-role-chooser]');
    if (!group || group.dataset.bnxVideoReady === 'true') return;
    group.dataset.bnxVideoReady = 'true';
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    const cards = Array.from(group.querySelectorAll('.bn-mod-role')).filter((card) => card.querySelector('video'));
    cards.forEach((card) => {
      const video = card.querySelector('video');
      const media = card.querySelector('.bn-mod-role__media');
      primeDeferredVideo(video);
      if (media && !media.querySelector('.bnx-video-cue')) {
        const cue = document.createElement('span');
        cue.className = 'bnx-video-cue';
        cue.textContent = 'TAPnij, żeby odtworzyć';
        media.appendChild(cue);
      }
      card.addEventListener('click', (event) => {
        if (!event.target.closest('.bn-mod-role__media') || !video.paused) return;
        event.preventDefault();
        selectVideoCard(group, card, video, 'home_steps_tap');
      });
      if (finePointer.matches) {
        card.addEventListener('mouseenter', () => selectVideoCard(group, card, video, 'home_steps_hover'));
        card.addEventListener('mouseleave', () => pauseVideo(video, true));
      }
      card.addEventListener('focus', () => selectVideoCard(group, card, video, 'home_steps_focus'));
    });
    if (cards[0]) selectVideoCard(group, cards[0], cards[0].querySelector('video'), 'home_steps_default', false);
  };

  const setupStepCardVideos = () => {
    const group = document.querySelector('[data-bn-baza-kolor-top]');
    if (!group || group.dataset.bnxVideoReady === 'true') return;
    group.dataset.bnxVideoReady = 'true';
    const cards = Array.from(group.querySelectorAll('.card')).filter((card) => card.querySelector('video'));
    cards.forEach((card) => {
      const video = card.querySelector('video');
      primeDeferredVideo(video);
      addVideoTrigger(card, video, 'home_flow', group);
    });
    if (cards[0]) selectVideoCard(group, cards[0], cards[0].querySelector('video'), 'home_flow_default', false);
  };

  const setupVideoSystem = () => {
    if (!document.body.classList.contains('bn-home-v2')) return;
    if (document.documentElement.dataset.bnxVideoEvents !== 'true') {
      document.documentElement.dataset.bnxVideoEvents = 'true';
      document.addEventListener('play', (event) => {
        const video = event.target;
        if (!(video instanceof HTMLVideoElement)) return;
        const group = video.closest('[data-bn-quick-clean],[data-bn-drop-live],[data-bn-home-role-chooser],[data-bn-baza-kolor-top]');
        const selectedVideo = group?.querySelector('.is-video-selected video');
        if (selectedVideo && selectedVideo !== video) {
          pauseVideo(video);
          return;
        }
        stopOtherVideos(video);
        activeVideo = video;
        setVideoState(video, true);
      }, true);
      document.addEventListener('pause', (event) => {
        const video = event.target;
        if (!(video instanceof HTMLVideoElement)) return;
        setVideoState(video, false);
        if (activeVideo === video) activeVideo = null;
      }, true);
    }

    document.querySelectorAll('video').forEach((video) => {
      if (!video.closest('.bnv2-hero')) primeDeferredVideo(video);
    });
    setupHeroVideo();
    setupQuickVideos();
    setupDropVideos();
    setupRoleVideos();
    setupStepCardVideos();
  };

  const boot = () => {
    document.body.classList.add('bn-neon-review');
    addStack(document.querySelector('.bnv2-hero'), 'hero');
    addStack(document.querySelector('[data-bn-quick-clean]'), 'quick');
    addStack(document.querySelector('[data-bn-drop-live]'), 'drop');
    addStack(document.querySelector('.bn-start-bridge'), 'start');
    addStack(document.querySelector('[data-bn-home-role-chooser], [data-bn-baza-kolor-top]'), 'steps');
    addStack(document.querySelector('[data-bn-home-community]'), 'community');
    addStack(document.querySelector('body#wszystkie-kolory .bn-mod-hero'), 'colors-page');
    addStack(document.querySelector('body#bazy-i-topy #bn-bt-routines'), 'bases-page');
    addStack(document.querySelector('body#zacznij #bn-start-top'), 'start-page');
    addStack(document.querySelector('body#akcesoria .bn-acc-toolkit'), 'accessories-page');
    addStack(document.querySelector('body#zestawy [id^="BNMainSets-"]'), 'sets-page');
    addStack(document.querySelector('body#nowosci-dropy .bn-drop-vote'), 'drop-vote');
    copyDropSwatches();
    setupVideoSystem();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.addEventListener('load', boot, { once: true });
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:reorder', boot);
})();
